export const miraRoutes = [
    route('startup', '/', 'startup', false),
    route('login', '/auth', 'auth', false),
    route('register', '/register', 'auth', false),
    route('onboarding-profile', '/onboarding/profile', 'form', true),
    route('onboarding-birth', '/onboarding/birth', 'form', true),
    route('onboarding-relationship', '/onboarding/relationship', 'form', true),
    route('today', '/today', 'main-tab', true, { mainTab: 'today' }),
    route('chat', '/chat/:conversationId', 'chat', true, { fullScreen: true }),
    route('topics', '/topics', 'main-tab', true, { mainTab: 'topics' }),
    route('topic-detail', '/topics/:topicId', 'main-tab', true, { mainTab: 'topics' }),
    route('relationships', '/relationships', 'main-tab', true, { mainTab: 'relationships' }),
    route('relationship-new', '/relationships/new', 'form', true),
    route('relationship-detail', '/relationships/:relationshipId', 'main-tab', true, { mainTab: 'relationships' }),
    route('memory', '/memory', 'main-tab', true, { mainTab: 'memory' }),
    route('settings', '/settings', 'detail', true),
    route('settings-profile', '/settings/profile', 'form', true),
    route('settings-birth', '/settings/birth', 'form', true),
    route('settings-password', '/settings/password', 'form', true),
    route('settings-privacy', '/settings/privacy', 'detail', true),
    route('privacy', '/privacy', 'legal', false),
    route('terms', '/terms', 'legal', false),
];
export const miraRouteIds = miraRoutes.map((item) => item.id);
export function routeById(id) {
    const routeConfig = miraRoutes.find((item) => item.id === id);
    if (!routeConfig)
        throw new Error(`Unknown Mira route: ${id}`);
    return routeConfig;
}
function route(id, path, kind, requiresAuth, options = {}) {
    return { id, path, kind, requiresAuth, ...options };
}
